import { useGetBoMeQuery, TENANT_CONTEXT_STORAGE_KEY, TENANT_CONTEXT_ALL } from "../store/services/api";

export interface TenantScope {
  /** True mientras se resuelve la identidad (/bo/me). */
  loading: boolean;
  /** Rol del operador de BO. */
  role?: "SUPER_ADMIN" | "TENANT_ADMIN" | "MEMBER";
  /**
   * True cuando el tenant queda fijado por el contexto y el usuario NO puede elegirlo:
   * - TENANT_ADMIN: siempre (su tenant).
   * - SUPER_ADMIN: cuando hay un tenant seleccionado en el selector (distinto de "Todos").
   */
  locked: boolean;
  /**
   * True cuando el campo de tenant debe ocultarse por completo (TENANT_ADMIN: no aplica elegir).
   */
  hidden: boolean;
  /** Tenant que el backend va a forzar; null si el scope es global (SUPER_ADMIN con "Todos"). */
  tenantId: string | null;
}

/**
 * MT-011 — Resuelve el scope de tenant para los formularios del BO.
 * El backend ya fuerza el tenant del scope server-side; este hook es solo para la UX
 * (ocultar/bloquear el dropdown de tenant según corresponda).
 */
export function useTenantScope(): TenantScope {
  const { data: me, isLoading } = useGetBoMeQuery();

  if (isLoading || !me) {
    return { loading: isLoading, role: me?.role, locked: false, hidden: false, tenantId: null };
  }

  if (me.role === "TENANT_ADMIN") {
    return { loading: false, role: me.role, locked: true, hidden: true, tenantId: me.tenantId };
  }

  if (me.role === "SUPER_ADMIN") {
    const selected = sessionStorage.getItem(TENANT_CONTEXT_STORAGE_KEY);
    if (selected && selected !== TENANT_CONTEXT_ALL) {
      return { loading: false, role: me.role, locked: true, hidden: false, tenantId: selected };
    }
    return { loading: false, role: me.role, locked: false, hidden: false, tenantId: null };
  }

  return { loading: false, role: me.role, locked: false, hidden: false, tenantId: null };
}
